<template>
  <div class="discount-credentials">
    <credentials-details
      :invalid-credentials="invalidCredentials"
      :source="discountSource"
      :name-already-used-error="nameAlreadyUsedError"
      :set-name-already-in-use-error="setNameAlreadyInUseError"
      :save-credentials-error="saveCredentialsError"
      :update-mode="updateMode"
      :on-save="onSave">
      <template v-slot:title>
        <div class="title">
          לחיבור החשבון צריך להזין את <span class="bold">פרטי המשתמש הקבועים</span> לאתר דיסקונט או
          <span class="discount-direct-link" v-on:click="scrollToDiscountDirect">להתחבר ישירות דרך אתר דיסקונט</span>
        </div>
      </template>
    </credentials-details>
    <div class="separator">
      <div class="line"></div>
      <div class="or">או</div>
      <div class="line"></div>
    </div>
    <discount-credentials-details id="discount-credentials"
                                  :name-already-used-error="nameAlreadyUsedError"
                                  :set-name-already-in-use-error="setNameAlreadyInUseError"
                                  :save-discount-credentials="saveDiscountDirect"
                                  :validate-name="validateName"
                                  :show-logo="false"
                                  :source="discountDirectSource">
      <template v-slot:title>
        <div class="title">
          <div class="bold">חיבור ישיר דרך אתר דיסקונט</div>
          <div>מומלץ לחיבור חשבון אישי - כזה שרשום ומנוהל על ידי אדם אחד בלבד.</div>
          <div>חיבור חשבון משותף - תלוי באישור נוסף של הבנק ויקח מספר ימים.</div>
        </div>
      </template>
    </discount-credentials-details>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import effectsUtils from '@/store/utilities/effects';
import PromotionPopup from '@/base-components/onboarding/discount/PromotionPopup';
import CredentialsDetails from '@/base-components/onboarding/CredentialsDetails';
import DiscountCredentialsDetails from '@/base-components/onboarding/discount/DiscountCredentialsDetails';
import { getSourceConfigurationBySourceName } from '@/constants/sourcesConfiguration';

export default {
  name: 'DiscountCredentials',
  components: {
    DiscountCredentialsDetails,
    CredentialsDetails,
  },
  data() {
    return {
      discountPopupClosed: false,
    };
  },
  created() {
    this.discountPopupClosed = localStorage.getItem('riseup.discountPopupClosed');
    if (!this.discountPopupClosed) {
      this.openModal({
        component: PromotionPopup,
        props: {
          closePopup: this.closeDiscountPopup,
        },
      });
    }
  },
  mounted() {
    if (this.source.sourceName === 'דיסקונט ישיר') {
      this.scrollToDiscountDirect();
    }
  },
  props: {
    source: {
      type: Object,
      required: true,
    },
    onSave: {
      type: Function,
      required: true,
    },
    saveDiscountDirect: {
      type: Function,
      required: true,
    },
    nameAlreadyUsedError: {
      type: Boolean,
      default: false,
    },
    saveCredentialsError: {
      type: Boolean,
      default: false,
    },
    setNameAlreadyInUseError: {
      type: Function,
    },
    invalidCredentials: {
      type: Boolean,
      default: false,
    },
    showLogo: {
      type: Boolean,
      default: true,
    },
    validateName: {
      type: Function,
    },
    updateMode: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    discountSource() {
      return getSourceConfigurationBySourceName('דיסקונט');
    },
    discountDirectSource() {
      return getSourceConfigurationBySourceName('דיסקונט ישיר');
    },
  },
  methods: {
    ...mapActions('modalRootStore', ['openModal']),
    scrollToDiscountDirect() {
      effectsUtils.scrollToElement('discount-credentials');
    },
    closeDiscountPopup() {
      localStorage.setItem('riseup.discountPopupClosed', true);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../node_modules/base-ui/src/scss/riseup-colors';
@import '../../../scss/mixins';

.discount-credentials {
  background-color: $riseup_white;

  .title {
    color: $riseup_black;
    font-size: 18px;
    line-height: 1.44;
    margin-bottom: 20px;

    .bold {
      font-weight: bold;
      margin-bottom: 10px;
    }

    .discount-direct-link {
      text-decoration: underline;
      color: $riseup_blue;
      cursor: pointer;
      font-weight: bold;
    }
  }

  .separator {
    @include responsive-padding;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    color: $riseup_gray_2;

    .line {
      height: 1px;
      width: 100%;
      background-color: $riseup_gray_1;
    }

    .or {
      font-family: SimplerPro;
      color: $riseup_black;
      margin: 0 15px;
    }
  }
}
</style>
